import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CardQuick from '../../components/Card';
import { dashboardService } from "../../services";
import { useNavigate } from "react-router-dom";


const NextAppointmentsCard = ({locationId}) => {
    const [data,setData]=useState([])
    const navigate = useNavigate();
    useEffect(()=>{
        dashboardService.nextAppointments(locationId).then((data)=>{
            setData(data);
        }).catch(()=>{

        })
    },[locationId])


    
    const ScheduledDetail = ({item})=>{
        return(
            <Box sx={{display:'flex',gap:'16px',marginTop:'8px'}}>
                <Box sx={{display:'flex',color:'white',minWidth:'90px',alignItems:'center',justifyContent:'center', borderTopRightRadius: 4, borderBottomRightRadius: 4, borderBottomLeftRadius: 4, borderTopLeftRadius: 4 ,padding:'4px'}} bgcolor={'#0f172a'}>
                  <Typography sx={{ margin: 0 }} variant="h4" fontWeight={900}>{item.month_day}</Typography>
                  <Typography sx={{ margin: 0 }} variant="h4" fontWeight={400}>{item.month_name}</Typography>
                </Box>
                <Box>
                    <Typography variant="body1">{item.name}</Typography>
                    <Typography variant="body2">{item.subject_name}</Typography>
                </Box>
            </Box>
        )
    }

    return (
        <Box >
            <CardQuick>
                <Typography variant="h3">Proximas Consultas</Typography>
                 {data.map((item,index)=>(
                    <ScheduledDetail key={item.id} item={item} />
                 ))}
                 {data.length==0?<Typography>Sem Agendamentos.</Typography>:null}
            </CardQuick>
            <Box sx={{borderBottomLeftRadius:4,borderBottomRightRadius:4}} bgcolor={'#ececec'}>
            <Button onClick={()=>{
                navigate('schedules');
            }} sx={{margin:'8px'}} variant="contained" color="secondary2">Ver Agendamentos</Button>
            </Box>
        </Box>

    )

}

export default NextAppointmentsCard;